import { colors } from '@/lib/analytics/colors';
import { SIZE_25 } from '@/lib/gridElements/size';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { TIKTOK_BUSINESS } from '@/lib/socialProfile';
import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const totalViewsConfig = {
    name: 'kpi.tiktok.total_views',
    id: 'views',
    icon: {
        name: 'impressions',
        style: colors.purple
    },
    tooltip: 'kpi.tiktok.tooltip_total_views',
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_25,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    mergedData: true,
    element: KPIDefault,
    loader: DefaultLoader,
    dashboardEligibleNetworks: [TIKTOK_BUSINESS]
};
